<template>
  <button
    ref="refButtonSubtitle"
    class="button-white button-icon button-icon-bigger button-rounded"
    @click="onClickSubtitle"
    :class="{ active: isVisibleSubtitle }"
  >
    <IconSubtitle class="icon-medium" />
  </button>

  <DropdownModeNavigator
    v-if="isVisibleSubtitle"
    mode="subtitle"
    :target-el="refButtonSubtitle"
    @close="closeDropdownSubtitle"
  />
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';

import DropdownModeNavigator from '@/components/domains/chat/common/DropdownModeNavigator.vue';
import IconSubtitle from '@/components/icons/IconSubtitle.vue';

const refButtonSubtitle = useTemplateRef('refButtonSubtitle');
const isVisibleSubtitle = ref(false); // 자막 모드 드롭다운 보임 여부

// 자막 모드 드롭다운 열기
const openDropdownSubtitle = () => {
  isVisibleSubtitle.value = true;
};

// 자막 모드 드롭다운 닫기
const closeDropdownSubtitle = () => {
  isVisibleSubtitle.value = false;
};

// 자막 모드 버튼 클릭 시
const onClickSubtitle = () => {
  if (isVisibleSubtitle.value) {
    closeDropdownSubtitle();
  } else {
    openDropdownSubtitle();
  }
};
</script>

<style scoped lang="scss">
/* 필요 시 스타일 추가 */
</style>
